import { Component, input } from '@angular/core';
import { AppBrandSymbolComponent } from '../brand-symbol/brand-symbol.component';
import { AppBrandWordmarkComponent } from '../brand-wordmark/brand-wordmark.component';

@Component({
  selector: 'app-brand-logo',
  standalone: true,
  imports: [AppBrandSymbolComponent, AppBrandWordmarkComponent],
  host: { role: 'img', 'aria-label': 'Taskeo' },
  template: `
    <app-brand-symbol />
    @if (!compact()) {
      <app-brand-wordmark />
    }
  `,
  styles: [`
    :host { display: inline-flex; align-items: center; gap: .45em; flex-shrink: 0; color: inherit; font-size: 22px; line-height: 1; vertical-align: middle; }
    app-brand-symbol { width: 1em; height: 1em; }
    app-brand-wordmark { width: 3.66750em; height: .9em; }
  `],
})
export class AppBrandLogoComponent {
  readonly compact = input(false);
}
